import { useEffect, useRef, useState } from "react";
import { useTheme } from "context/ThemeContext";
import { useSettings } from "context/SettingsContext";
import { Editor } from "@tinymce/tinymce-react";
import { baseTinyInit } from "./baseTinyInit";
import { forwardRef } from "react";
import ESpinner from "components/others/Spinner";

const ETiny = forwardRef(({value = null, defaultValue, onChange, init, minHeight, autoFucus = false, disabled = false}, ref) => {

    //const { value, handleChange, init = {}, ...otherProps } = props;
    const { settings } = useSettings();
    const { darkTheme } = useTheme()
    const [ contentCss, setContentCss] = useState(darkTheme ? 'dark' : 'default');
    const [ skin, setSkin ] = useState(darkTheme ? 'oxide-dark' : 'oxide');
    const [ showClass, setShowClass ] = useState('d-none');
    const [ valueInner, setValueInner ] = useState(defaultValue||'');
    const [ initProcess, setInitProcess ] = useState(true); 
    const refEditContainer = useRef();
    
    // Підставляємо арі ключ, якщо прописний в параметрах
    const apiKey = settings?.global?.integration?.tiny?.apiKey
            ? {apiKey : settings?.global?.integration?.tiny?.apiKey}
            : {tinymceScriptSrc:'/tiny/tinymce/js/tinymce/tinymce.min.js'};
 
    // Оновлюємо тему редактора при зміні `darkTheme`
    useEffect(() => {
        setSkin(darkTheme ? 'oxide-dark' : 'oxide');
        setContentCss(darkTheme ? 'dark' : 'default');
        
    }, [darkTheme]);    

    
    const handleInnerChange = (newValue) => {
        if (typeof onChange === 'function') onChange(newValue)
            else setValueInner(newValue)
    }

    const insertFromClipboard = async (editor) => {
        try {
            if (!navigator?.clipboard?.readText) {
                editor.notificationManager.open({
                    text: "Браузер не підтримує читання буфера обміну.",
                    type: "warning",
                });
                return;
            }

            const clipboardText = await navigator.clipboard.readText();
            if (!clipboardText) return;

            const safeHtml = editor.dom
                .encode(clipboardText)
                .replace(/\r?\n/g, "<br />");
            editor.insertContent(safeHtml);
        } catch (error) {
            editor.notificationManager.open({
                text: "Не вдалося вставити з буфера. Перевірте дозволи браузера.",
                type: "error",
            });
            console.error("TinyMCE clipboard paste error:", error);
        }
    };

    return (
        <div style={{minHeight:300}}>
        <div className={showClass} ref={refEditContainer}>
        <Editor 
            ref={ref}
            {...apiKey}
            disabled={disabled}
            value={value!==null ? value : valueInner}
            init={{
                skin: skin,
                content_css: contentCss,
                ...baseTinyInit,
                ...init,
                setup: (editor) => {
                    editor.ui.registry.addIcon(
                        "pasteFromClipboardIcon",
                        '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M16 2h-2.18C13.4.84 12.3 0 11 0S8.6.84 8.18 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 19H6V4h2v2h6V4h2v16zM8 10h6v2H8v-2zm0 4h6v2H8v-2z"/></svg>'
                    );

                    editor.ui.registry.addButton("pasteFromClipboard", {
                        icon: "pasteFromClipboardIcon",
                        tooltip: "Вставити з буфера",
                        onAction: () => insertFromClipboard(editor),
                    });

                    editor.ui.registry.addMenuItem("pasteFromClipboard", {
                        text: "Вставити",
                        icon: "pasteFromClipboardIcon",
                        onAction: () => insertFromClipboard(editor),
                    });

                    editor.on("Error", (error) => {
                        console.error("TinyMCE Error:", error);
                    });

                    editor.on("init", () => {
                        if (autoFucus)
                        setTimeout(() => {editor.focus();}, 100);                          
                        setShowClass(""); // Відображаємо редактор після ініціалізації
                    });

                    if (typeof init?.setup === "function") {
                        init.setup(editor);
                    }
                }
            }}
            onEditorChange={handleInnerChange}
            onInit={(evt, editor)  => {
                setInitProcess(false);
                editor.setContent(defaultValue || '');
                const tox = refEditContainer.current?.querySelector('.tox-promotion');
                if (tox) tox.style.display = 'none'; // Ховаємо рекламу TinyMCE
                setShowClass('');
            }}
        />
        </div>
        </div>
    )

});

export default ETiny;